/* eslint-disable camelcase */
import React, { createContext, useState, useEffect } from "react";
// eslint-disable-next-line import/no-unresolved
import { globalHistory } from "@reach/router";
import { useSettings } from "~hooks";

export const AppContext = createContext({});

/** ============================================================================
 * @component
 * Global state provider for lightboxes and headers.
 * @return {node}  todo: document
 */
const AppProvider = ({ children }) => {
  // --------------------------------------------------------------------------
  // context / ref / state

  const [modalActive, setModalActive] = useState(false);
  const [navActive, setNavActive] = useState(false);
  const [toastActive, setToastActive] = useState(false);
  const [navPreselect, setNavPreselect] = useState(null);
  const [headerOffset, setHeaderOffset] = useState(null);
  const [insightsMode, setInsightsMode] = useState(false);
  const [isCampaignPage, setIsCampaignPage] = useState(false);
  const [insightsTheme, setInsightsTheme] = useState(`dark`);
  const [pathname, setPathname] = useState(null);
  const [enablePromoBanner, setEnablePromoBanner] = useState(false);
  const [enableNewsletterSignup, setEnableNewsletterSignup] = useState(false);

  const settings = useSettings();
  // --------------------------------------------------------------------------
  // lifecycle

  useEffect(() => {
    if (typeof window === `undefined`) return;

    window.sessionStorage.setItem(`firstPage`, window.location.href);

    if (isCampaignPage)
      window.sessionStorage.setItem(`campaignPage`, window.location.href);

    return () => window.sessionStorage.clear();
  }, [isCampaignPage]);

  useEffect(() => {
    if (typeof window !== `undefined` && window?.location?.pathname) {
      setPathname(window.location.pathname);
    }

    return globalHistory.listen(({ location }) => {
      setPathname(location.pathname);
    });
  }, []);

  useEffect(() => {
    if (!pathname) {
      return;
    }
    setInsightsMode(pathname.startsWith(`/insights`));
    setIsCampaignPage(pathname.startsWith(`/discover/`));
  }, [pathname]);

  useEffect(() => {
    if (!toastActive) return;

    setTimeout(() => {
      setToastActive(false);
    }, 2000);
  }, [toastActive]);

  useEffect(() => {
    const promoBanner = settings.getPromoBanner();

    if (pathname === `/` && promoBanner?.content?.headline) {
      setEnablePromoBanner(true);
    } else {
      setEnablePromoBanner(false);
    }
  }, [pathname, settings]);

  useEffect(() => {
    const newsletterSignup = settings.getNewsletterSignup();

    if (newsletterSignup?.content?.formId) {
      setEnableNewsletterSignup(true);
    } else {
      setEnableNewsletterSignup(false);
    }
  }, [settings]);

  // --------------------------------------------------------------------------
  // render

  return (
    <AppContext.Provider
      value={{
        insightsMode,
        insightsTheme,
        setInsightsTheme,
        pathname,
        modalActive,
        setModalActive,
        navActive,
        setNavActive,
        toastActive,
        setToastActive,
        navPreselect,
        setNavPreselect,
        headerOffset,
        setHeaderOffset,
        enablePromoBanner,
        isCampaignPage,
        enableNewsletterSignup
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
